var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8937 1.66797H6.1085C3.27147 1.66797 1.66406 3.27538 1.66406 6.11241V13.8902C1.66406 16.7272 3.27147 18.3346 6.1085 18.3346H13.8937C16.7307 18.3346 18.3307 16.7272 18.3307 13.8902V6.11241C18.3307 3.27538 16.7307 1.66797 13.8937 1.66797Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14202 7.80859C5.76424 7.80859 5.45312 8.1197 5.45312 8.50486V14.2308C5.45312 14.6086 5.76424 14.9197 6.14202 14.9197C6.5272 14.9197 6.83832 14.6086 6.83832 14.2308V8.50486C6.83832 8.1197 6.5272 7.80859 6.14202 7.80859Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0327 5.07422C9.65483 5.07422 9.34375 5.38533 9.34375 5.77051V14.2297C9.34375 14.6076 9.65483 14.9187 10.0327 14.9187C10.4178 14.9187 10.7289 14.6076 10.7289 14.2297V5.77051C10.7289 5.38533 10.4178 5.07422 10.0327 5.07422Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8681 10.8281C13.483 10.8281 13.1719 11.1393 13.1719 11.5245V14.2281C13.1719 14.606 13.483 14.917 13.8607 14.917C14.2459 14.917 14.557 14.606 14.557 14.2281V11.5245C14.557 11.1393 14.2459 10.8281 13.8681 10.8281Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.77e2dc2075c75fc5039cd9431e56cacb.svg";
export { ForwardRef as ReactComponent };